export default __webpack_public_path__ + "static/media/previous-track.482625f4.png";